const tradingVenueGroup = {
  icap: 1,
  tullet: 2,
  pvm: 3
};

const enumsConstant = {
  tradingVenueGroup
};

export default enumsConstant;



// WEBPACK FOOTER //
// ./src/common/constants/enumsConstant.js